document.querySelectorAll('.video-wrap').forEach((videoWrap) => {
    const video = videoWrap.querySelector('a.video-mp4, button.video-mp4');

    if (!video) return;

    const thisVideoSrc = video.dataset.src;
    const thisVTTSrc = video.dataset.vttSrc;
    const thisVTTLabel = video.dataset.vttLabel;
    const thisVTTSrcLang = video.dataset.vttSrclang;

    video.addEventListener('click', (event) => {
        event.preventDefault();

        const videoHTML = `<video class="video" controls>
            <source src="${thisVideoSrc}" type="video/mp4" />
            <track label="${thisVTTLabel}" kind="subtitles" srclang="${thisVTTSrcLang}" src="${thisVTTSrc}" />
        </video>`;

        video.outerHTML = videoHTML;
    });
});